import axios from 'axios';


// TODO : 특정 상황에서는 로딩을 길게 가도록록
const dispatchLoading = (loading, isForced=false) => {
    window.document.dispatchEvent(new CustomEvent(
        'loading', 
        { detail : { loading, isForced }}
    ));
}

class Http {

    static instance = null;

    static getAxios() {
        if (!Http.instance) {
            Http.instance = axios.create({
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json"
                }
            });

            Http.instance.interceptors.request.use(
                (config) => {
                    if (config.url.indexOf('isSelfLoading=true') === -1) {
                        dispatchLoading(true);
                    }
                    return config;
                },
                error => Promise.reject(error)
            );

            Http.instance.interceptors.response.use(
                (response) => {
                    dispatchLoading(false);
                    return response.data; // `res.data` 반환
                },
                (error) => {
                    dispatchLoading(false);
                    console.error("HTTP Error:", error);
                    if (error.response.data && error.response.data.message)
                        alert(error.response.data.message)
                    return Promise.reject(error);
                }
            );

        }
        return Http.instance;
    }


    static options = { 
        'withCredentials': true,
        'Content-Type': 'application/json' 
    };

    static get(url) {
        return Http.getAxios().get(url, Http.options);
    }

    static post(url, data, options) {
        return Http.getAxios().post(url, data, { ...Http.options, ...options });
    }

    static put(url, data) {
        return Http.getAxios().put(url, data, Http.options);
    }

    static delete(url) {
        return Http.getAxios().delete(url, Http.options);
    }

    static async download(url) {
        dispatchLoading(true);
        const response = await axios.get(url, {
            responseType: 'blob', // 파일 다운로드를 위한 설정
            withCredentials: true, // 인증이 필요한 경우
        });
        
        if (response.status === 200) {
            // 서버에서 파일명을 가져옴 (Content-Disposition 헤더)
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'slot_data.xlsx'; // 기본 파일명 (헤더가 없을 경우 대비)
            if (contentDisposition && contentDisposition.includes('filename=')) {
                const filenameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = decodeURIComponent(filenameMatch[1]); // URL 디코딩
                }
            }
        
            // 파일 다운로드 로직
            const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = filename; // 서버에서 받은 파일명 사용
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(downloadUrl);
        } else {
            console.error('Error: Unexpected response status', response.status);
        }
        dispatchLoading(false);        
    }
}

export default Http;
export { dispatchLoading }
